export default {
    PAYMENTS: '@get_payments',
    SEND_PAY: '@send_payments',
    RETURN_PAY: '@return_payments',
};
